//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
const moment = require('moment');

export default {
  name: "Calendar",
  components: {
    StockCard,
    SuccessDialog,
  },
  data() {
    return {
      menuDatePicker: false,
      menuDateModel: null,
      dialogVisible: false,
      selectedDate: '',
      selectedEvents: [],
      currentDateObj: new Date(),
      currentYear: null,
      currentMonthIndex: null, // 0 = January
      daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      holidaysByDate: {
        // "2025-06-01": [{ title: 'Labor Day', type: 'holiday' }],
      },
      personEventsByDate: {
        // "2025-06-04": [{ title: 'Somsak R.', type: 'person' },{ title: 'Somsak R.', type: 'person' }],
      },
      meetingEventsByDate: {
        // "2025-06-04": [
        //   { title: "Project Kickoff", type: "meeting" },
        // ],
        // "2025-06-05": [
        //   { title: "Project Kickoff2", type: "meeting" },
        // ]
      },
      // นัดหมายคดี / กำหนดส่งเอกสาร (เห็นเฉพาะแผนกเดียวกับคนสร้างคดี)
      caseEventsByDate: {},
      caseRequestId: 0,
      caseGroups: [
        { type: 'hearing', label: 'Case Appointments' },
        { type: 'deadline', label: 'Document Deadlines' },
      ],
      dialogAdd: false,
      text_color: '',
      title: '',
      message: '',
    };
  },
  computed: {
    currentFullDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const month = monthNames[today.getMonth()];
      const year = today.getFullYear();
      return `${day} ${month} ${year}`;
    },
    currentMonth() {
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[this.currentMonthIndex];
    },
    daysInMonth() {
      return new Date(this.currentYear, this.currentMonthIndex + 1, 0).getDate();
    },
    firstDayOfMonth() {
      return new Date(this.currentYear, this.currentMonthIndex, 1).getDay();
    },
    hasCaseEvents() {
      return Object.keys(this.caseEventsByDate).length > 0;
    },
    calendarGrid() {
      const totalCells = this.daysInMonth + this.firstDayOfMonth;
      const fullWeeks = Math.ceil(totalCells / 7);
      const totalGridCells = fullWeeks * 7;

      const grid = [];

      for (let i = 0; i < totalGridCells; i++) {
        const dayNumber = i - this.firstDayOfMonth + 1;
        if (dayNumber > 0 && dayNumber <= this.daysInMonth) {
          const dateKey = `${this.currentYear}-${String(this.currentMonthIndex + 1).padStart(2, '0')}-${String(dayNumber).padStart(2, '0')}`;

          const isHoliday = this.holidaysByDate[dateKey] && this.holidaysByDate[dateKey].length > 0;

          const dayEvents = [
            ...(this.holidaysByDate[dateKey] || []),
            ...(this.meetingEventsByDate[dateKey] || []),
            // ถ้าวันนั้นเป็นวันหยุด ไม่ต้องแสดงวันลา
            ...(isHoliday ? [] : (this.personEventsByDate[dateKey] || [])),
            // นัดคดีแสดงหลังวันหยุด / กิจกรรม / วันลา
            ...(this.caseEventsByDate[dateKey] || []),
          ];

          grid.push({
            date: dayNumber,
            events: dayEvents,
          });
        } else {
          grid.push({
            date: null,
            events: [],
          });
        }
      }
      return grid;
    }
  },
  async mounted() {
    // กำหนดค่าเริ่มต้นเป็นเดือนและปีปัจจุบัน
    this.currentYear = this.currentDateObj.getFullYear();
    this.currentMonthIndex = this.currentDateObj.getMonth();

    await api.checkVersion();

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // await api.checkttoken();
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    const now = new Date();
    this.menuDateModel = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

    await this.loadHoliday()
    await this.loadCompanyEvent()
    await this.loadLeave()
    await this.loadCaseEvents()

    this.$hideLoader();
  },
  methods: {
    handleMonthPicked(val) {
      const [year, month] = val.split("-").map(Number);
      this.currentYear = year;
      this.currentMonthIndex = month - 1;

      this.menuDateModel = val;
      this.menuDatePicker = false;

      this.loadHoliday();
      this.loadCompanyEvent();
      this.loadLeave();
      this.loadCaseEvents();
    },
    async loadHoliday() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0'); // เพราะ currentMonthIndex เริ่มจาก 0


      var data_search = {
        month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }

      var res_holiday = await api.getAllMonth({
        params: data_search
      })

      const rawData = res_holiday.data

      const holidaysByDate = {};

      rawData.forEach(item => {
        if (!holidaysByDate[item.date]) {
          holidaysByDate[item.date] = [];
        }
        holidaysByDate[item.date].push({
          ...item,
          title: item.h_name,
          type: 'holiday'
        });
      });

      this.holidaysByDate = holidaysByDate;
    },
    async loadCompanyEvent() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0');


      var data_search = {
        month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }

      var res_conpany_event = await api.getAllMonthEvent({
        params: data_search
      })
      const rawData = res_conpany_event.data

      const companyEventsByDate = {};

      rawData.forEach(item => {
        if (!companyEventsByDate[item.date]) {
          companyEventsByDate[item.date] = [];
        }
        companyEventsByDate[item.date].push({
          ...item,
          title: item.event_name,
          type: 'meeting'
        });
      });

      this.meetingEventsByDate = companyEventsByDate;
    },
    async loadLeave() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0');

      var data_leave_set = {
        date_month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }
      const res_leave = await api.getCalendar({ params: data_leave_set })
      // console.log("res_leave.data")
      // console.log(res_leave.data)

      var dataleave = Object.values(
        res_leave.data.reduce((acc, item) => {
          // สร้าง key โดยไม่เอา amount
          const key = `${item.userid}-${item.strc_date}-${item.leavetype}`;

          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key].amount = Number(item.amount) + Number(acc[key].amount);
          }

          return acc;
        }, {})
      );

      for (const [index, item] of dataleave.entries()) {
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor((Number(item.amount) / 60) / 8)
        leave_hours = Number(Number(item.amount) / 60) - (leave_day * 8);

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = ``
          } else if (leave_hours == 4) {
            item.description = item.description = `Half Day`
          } else if (leave_hours == 8) {
            item.description = item.description = `Full Day`
          } else {
            item.description = item.description = `${leave_hours} Hours`
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${leave_day} Day`
            } else {
              item.description = `Full Day`
            }
          } else {
            item.description = item.description = `${leave_day} Day ${leave_hours} Hours`
          }
        }

      }

      const rawData = dataleave;

      const leaveByDate = {};

      rawData.forEach(item => {
        const start = new Date(item.strc_date);
        const end = new Date(item.endc_date);

        // วนลูปตั้งแต่ start → end (รวม)
        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          const dayOfWeek = d.getDay(); // 0 = Sunday, 6 = Saturday
          if (dayOfWeek === 0 || dayOfWeek === 6) continue; // ข้ามเสาร์-อาทิตย์

          const dateStr = d.toISOString().slice(0, 10); // yyyy-mm-dd

          if (!leaveByDate[dateStr]) {
            leaveByDate[dateStr] = [];
          }

          leaveByDate[dateStr].push({
            ...item,
            show_image: `${imageUrl}/${item.image_profile}`,
            title: `${item.fullname}`,
            type: 'person'
          });
        }

      });

      this.personEventsByDate = leaveByDate;
    },
    // นัดหมายคดี + กำหนดส่งเอกสาร ของเดือนที่แสดง (API คืนเฉพาะคดีของแผนกตัวเอง)
    async loadCaseEvents() {
      const month = `${this.currentYear}-${String(this.currentMonthIndex + 1).padStart(2, '0')}`;
      const requestId = ++this.caseRequestId;   // กันผลของเดือนเก่ากลับมาทับ (กดเปลี่ยนเดือนเร็ว ๆ)
      try {
        const res = await api.getLitigationCalendar(
          month,
          Number(localStorage.getItem(server.DEPARTMENT_ID)),
          localStorage.getItem(server.ROLE) === 'ADMIN'   // ADMIN เห็นทุกแผนก
        );
        if (requestId !== this.caseRequestId) return;

        const byDate = {};
        (res.data || []).forEach(item => {
          (byDate[item.date] = byDate[item.date] || []).push({
            ...item,
            raw_title: item.title,
            title: item.time ? `${item.time} ${item.title}` : item.title,
            type: item.type,   // 'hearing' | 'deadline'
          });
        });
        this.caseEventsByDate = byDate;
      } catch (error) {
        // API คดีมีปัญหา → ปฏิทินส่วนอื่นยังใช้ได้ตามปกติ
        if (requestId === this.caseRequestId) this.caseEventsByDate = {};
        console.error('loadCaseEvents error:', error);
      }
    },
    // สถานะนัด / กำหนดส่ง (ชุดเดียวกับหน้า Docket)
    statusText(status) {
      return {
        not_started: 'Not started',
        in_progress: 'In progress',
        completed: 'Completed',
        overdue: 'Overdue',
        cancelled: 'Cancelled',
      }[status] || status || '';
    },
    statusTone(status) {
      return { in_progress: 'blue', completed: 'green', overdue: 'red' }[status] || 'grey';
    },
    openCase(event) {
      this.dialogVisible = false;
      this.$router.push(`/dispute-resolution-docket/${event.litigation_docket_id}`);
    },
    isToday(day) {
      if (!day.date) return false;
      const today = new Date();
      return (
        day.date === today.getDate() &&
        this.currentMonthIndex === today.getMonth() &&
        this.currentYear === today.getFullYear()
      );
    },
    prevMonth() {
      if (this.currentMonthIndex === 0) {
        this.currentMonthIndex = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonthIndex -= 1;
      }
      this.loadHoliday()
      this.loadCompanyEvent()
      this.loadLeave()
      this.loadCaseEvents()
    },
    nextMonth() {
      if (this.currentMonthIndex === 11) {
        this.currentMonthIndex = 0;
        this.currentYear += 1;
      } else {
        this.currentMonthIndex += 1;
      }
      this.loadHoliday()
      this.loadCompanyEvent()
      this.loadLeave()
      this.loadCaseEvents()
    },

    openDialog(day) {
      if (!day.date) return;
      this.selectedDate = `${moment.tz(`${this.currentYear}-${String(this.currentMonthIndex + 1).padStart(2, '0')}-${String(day.date).padStart(2, '0')}`, "Asia/Bangkok").format('ddd, DD MMMM yyyy')}`;
      // this.selectedDate = `${String(day.date).padStart(2, '0')}/${String(this.currentMonthIndex + 1).padStart(2, '0')}/${this.currentYear}`;
      this.selectedEvents = day.events || [];
      this.dialogVisible = true;
    },
    getColor(type) {
      switch (type) {
        case 'holiday':
          return '#B6272B';
        case 'person':
          return '#055DAA';
        case 'meeting':
          return '#FFDE59';
        default:
          return '#333';
      }
    },
    filteredByType(type) {
      return this.selectedEvents.filter(e => e.type === type); // แสดงทั้งหมด
    },
    goToToday() {
      const today = new Date();
      this.currentYear = today.getFullYear();
      this.currentMonthIndex = today.getMonth();
      this.loadHoliday();
      this.loadCompanyEvent();
      this.loadLeave();
      this.loadCaseEvents();
    },
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
